// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"rP-z","inlineTitle":"sP-z","sponsoredAdsWrapper":"tP-z","marketplaceRecosWrapper":"uP-z"};